// custom javascript

// function output messages via console
// ACHTUNG: tt_log gibt nur etwas aus, wenn der Shop im Testmodus l�uft!
var tt_log = function(obj) {
	if ((typeof(euramin_testmode)!=='undefined') && (euramin_testmode===true)) {
		if (window.console && window.console.log) {
			window.console.log(obj);
		}
	}
};



/*
// optimize smartmenu
$(function(){
	// tt_log('javascript initialized.');

	$('.eu-header-main-container ul.navbar-nav').smartmenus({
		// mainMenuSubOffsetX: 1,
		// mainMenuSubOffsetY: -8,
		// markCurrentItem: true,
		// markCurrentTree: true,
		showOnClick: true,
		subIndicators: false,
		hideOnClick: false
	});

	// --- always open submenu in offcanvas layer ---

	function doOnBreakpoint ( breakpoint ) {
		var item = $('.eu-nav-item-first');
	    if ( breakpoint === 'sm' ) { // zuordnung ge�ndert in media-query-sync.scss -> bootstrap custom xxs = xs, xs = sm
	    	item.addClass('open');
	    } else {
	    	item.removeClass('open');
	    }
	};

 	window.addEventListener( 'deviceStateChanged', function( event ) {
		// console.log( 'another breakpoint was reached: ' + event.deviceState );
	    doOnBreakpoint( event.deviceState );
	}, false );
 	doOnBreakpoint(	mediaQuerySync.getDeviceState() );

	$(window).on('deviceStateChanged', function( event ) {
		console.log( 'another breakpoint was reached: ' + event.deviceState );
	});

});
*/



$(function () {

	// init jsonly-visibility:
	$('.shop-jsonly-visible').show();

	// init bootstrap popovers:
	$('[data-toggle="popover"]').popover();

	// shop button back to top
	(function () {
		var duration = 0.25 * 1000,
			btn = $('<div></div>')
			.attr('class', 'shop-button-back-to-top')
			.appendTo($('body'))
			.hide()
			.on('click', function () {
				$.scrollTo(0, duration);
			})
			.on('mouseenter', function(){
				btn.css('opacity', 0.75);
			})
			.on('mouseleave', function(){
				btn.css('opacity', 0.5);
			})
		;
		$(window).scroll(function () {
			if ($(window).scrollTop() > $(window).height()) {
				if (!btn.is(':visible') && !btn.is(':animated')) {
					btn.fadeIn(duration);
				}
			} else {
				if (btn.is(':visible') && !btn.is(':animated')) {
					btn.fadeOut(duration);
				}
			}
		});

	})();



	// prevent typographic orphans/widows
	/**
	 * removes typographic widows
	 * works only with non-nested elements, like h1, h2, etc.; don't apply to div, p with nested a etc.
	 * 2014-07-04 more robust implementation: searches and modifies last "grandchild"-element in selection
	 * e.g. if a <p> contains a <strong> which contains the text
	 */
	/*
	(function ($) {
		$.fn.unwidow = function () {
			return this.each(function () {
				var target = $(this).find('*').addBack().last();                // addBack = Add the previous set of elements on the stack to the current set, optionally filtered by a selector.
				target.html(target.text().replace(/ (\S+)$/, '&nbsp;$1'));      // \S = matches non-whitespace-characters
			});
		};
	}(jQuery));
	// unwidow �berall anwenden, wo es n�tig ist:
	// $('.shop-product-headline').unwidow();
	*/


	/* version ohne regex, funktioniert aber auch mit verschachtelten html-elementen und findet dann trotzdem korrekt die letzten beiden w�rter */
	/*
	(function ($) {
		$.fn.unwidow = function () {
			return this.each(function () {
				var wordArray = $(this).html().split(' ');
				if (wordArray.length > 1) {
					wordArray[wordArray.length - 2] += '&nbsp;' + wordArray[wordArray.length - 1];
					wordArray.pop();
					$(this).html(wordArray.join(' '));
				}
			});
		};
	}(jQuery));
	$('.shop-unwidow').unwidow();
	*/




	/* hotline-layer */

	$('.shop-layer-hotline-box-label').on('click', function() {

		var label = $('.shop-layer-hotline'),
			openClass = 'shop-layer-hotline-open';

		if (label.hasClass(openClass)) {
			label.removeClass(openClass);
		} else {
			label.addClass(openClass);
		}

	});

	$('.shop-layer-hotline-close-btn').on('click', function() {

		$('.shop-layer-hotline').removeClass('shop-layer-hotline-open');

	});

	$(window).on('scroll', function () {
		var layer = $('.shop-layer-hotline'),
			scroll_offset = $(window).height();
		if ( /* $(window).outerWidth()<768 && */ $(this).scrollTop()>scroll_offset) {
			layer.fadeOut(50);
		} else {
			layer.fadeIn(50);
		}
	}).on('resize', function() {
		var layer = $('.shop-layer-hotline'),
			scroll_offset = $(window).height();
		if ( /* $(window).outerWidth()<768 && */ $(this).scrollTop()>scroll_offset) {
			layer.fadeOut(50);
		} else {
			layer.fadeIn(50);
		}
	});

});



// enhance forms
// floating/animated form label pattern
// todo: simplify and optimize selectors
// $(function() {
$(document).on('ready ajaxComplete', function () {

	// tt_log('ready ajaxcomplete');

	// labels initial hochstellen, sofern bereits ein wert eingegeben oder ausgew�hlt ist:
	function initFormFieldLabels () {
		// tt_log($(':password').eq(0).val());
		$('input.form-control, .form-control select, textarea.form-control').each(function () {
			var self = $(this),
				label = self.closest('.form-group').find('label.control-label'),
				value = self.val();
			// tt_log(self);
			// tt_log(value);
			if ( typeof(value)!=='undefined' && ( value !== '' ) && ( value.indexOf('empty') < 0 ) && !label.hasClass('shop-form-label-across') ) {
				label.addClass('above');
			}
		});
	};
	initFormFieldLabels();

	// label-animation aktivieren (erst jetzt, �ber events, da die Animation nicht beim Laden der Seite laufen soll):
	$('label.control-label').closest('.form-group').find('input:text, input[type="email"], input:password, select, textarea').on('focus change', function () {
		$(this).closest('.form-group').find('label.control-label').addClass('transition-active');
		// tt_log('focus');
	});

	// inputs focus
	$('label.control-label').closest('.form-group').find('input:text, input[type="email"], input:password, select, textarea').on('focus', function () {
		$(this).closest('.form-group').find('label.control-label').addClass('above');
	});

	// inputs blur
	$('label.control-label').closest('.form-group').find('input:text, input[type="email"], input:password, textarea').on('blur', function () {
		var self = $(this),
			value = $.trim(self.val());
		if ( value === '' ) {
			self.closest('.form-group').find('label.control-label').removeClass('above');
		}
	});

	// selects change
	// $('label.control-label').closest('.form-group').find('select').on('change', function () {
	$('.form-group').find('select').on('change', function () {
		var self = $(this),
			value = $.trim(self.val());
		if ( value.indexOf('empty') != -1 || value==='' ) {
			self.closest('.form-group').find('label.control-label').removeClass('above');
		} else {
			self.closest('.form-group').find('label.control-label').addClass('above');
		}
	});

	/**
	 * todo: derzeit muss man auf das select (titel) 2 x klicken, bevor sich die listbox �ffnet
	 * das muss einfacher werden!
	 */
	// when clicking on labels
	// $('.form-group-select label.control-label').on('click', function () {
	// $('.form-group-input input, .form-group-select select').on('click', function () {
	$('.form-group .control-label').on('click', function () {
		// tt_log('click on select-label');
		var self = $(this);
		self.addClass('transition-active above');
		self.closest('.form-group').find('select, input').eq(0).focus();
		// tt_log('click on label');
	});
	// selects blur
	$('.form-group-select select').on('blur', function () {
		var self = $(this),
			value = $.trim(self.val());
		if ( value.indexOf('empty') != -1 ) {
			self.closest('.form-group').find('label.control-label').removeClass('above');
		} else {
			self.closest('.form-group').find('label.control-label').addClass('above');
		}
	});

	/*
	if ($('html#login').length) {
		// passwords may be populated by the browser - a bit later than on ready or ajaxcomplete
		setInterval(function(){initFormFieldLabels()}, 1000);
		// setInterval("tt_log('ping3');",1000);
		// $(window).click();
	}
	*/





	// pay_deliv -- custom radio buttons instead of system radio buttons
	// payment
	$('html#shop-pay-deliv').find('.ws_paymentdiv_main').each(function(){
		var self = $(this),
			radio = $('<div class="shop-paymentdiv-radio-wrapper"><div class="shop-paymentdiv-radio"></div></div>');
		self.prepend(radio);
		self.find('.ws_paymentdiv_name, .ws_paymentdiv_remarks').wrapAll('<div class="shop-paymentdiv-text-group"></div>');
		self.find('.ws_paymentdiv_logo').show().prependTo(self.find('.ws_paymentdiv_text'));
	});
	/* // ganze fl�che
	$('html#shop-pay-deliv').find('.ws_paymentdiv_main').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		var self = $(this);
		self.find(':radio').eq(0).prop('checked', true);
		$('.shop-paymentdiv-radio').removeClass('active');
		self.find('.shop-paymentdiv-radio').addClass('active');
	});
	*/
	$('html#shop-pay-deliv .ws_paymentdiv_main :radio:checked').closest('.ws_paymentdiv_main').find('.shop-paymentdiv-radio').addClass('active');
	// nur radiobutton
	$('html#shop-pay-deliv').find('.ws_paymentdiv_main .shop-paymentdiv-radio').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		var self = $(this);
		self.closest('.ws_paymentdiv_main').find(':radio').prop('checked', true);
		$('.shop-paymentdiv-radio').removeClass('active');
		self.addClass('active');
	});

	// delivery
	$('html#shop-pay-deliv').find('.ws_deliverydiv_main').each(function(){
		var self = $(this),
			radio = $('<div class="shop-deliverydiv-radio-wrapper"><div class="shop-deliverydiv-radio"></div></div>');
		self.prepend(radio);
		self.find('.ws_deliverydiv_name, .ws_deliverydiv_remarks').wrapAll('<div class="shop-deliverydiv-text-group"></div>');
		self.find('.ws_deliverydiv_logo').show().prependTo(self.find('.ws_deliverydiv_text'));
	});
	$('html#shop-pay-deliv').find('.ws_deliverydiv_main').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		var self = $(this);
		self.find(':radio').eq(0).prop('checked', true);
		$('.shop-deliverydiv-radio').removeClass('active');
		self.find('.shop-deliverydiv-radio').addClass('active');
	});
	$('html#shop-pay-deliv .ws_deliverydiv_main :radio:checked').closest('.ws_deliverydiv_main').find('.shop-deliverydiv-radio').addClass('active');

	// wenn es nur 1 delivery-Option gibt, dann komplett ausblenden:
	if ($('.ws_deliverydiv_main').length===1) {
		$('.shop-box-shipping-methods-wrapper').hide();
	}

	// setze disabled-klasse auf labels von disabled-checkboxen
	$('.form-group-checkbox input:checkbox').each(function(){
		$checkbox = $(this);
		if ($checkbox.is(':disabled')) {
			$checkbox.closest('.form-item').find('label').addClass('shop-checkbox-disabled');
		}
	});



	// 2022-10 -- filter payment methods for some maildomains
	// $('html#shop-pay-deliv.shop-testmode').each(function(){
	$('html#shop-pay-deliv').each(function(){
		// console.log('TESTMODE 2214');
		// shop_global_email = 'mail@example.ru';
		var payment_div_bill_selector = '#ws_paymentdiv_main_id_6';
		if (typeof(shop_global_email)!=='undefined' && shop_global_email.substring(shop_global_email.length-3)==='.ru' && $(payment_div_bill_selector).length) {
			// $('.shop-box-payment-methods .ws_paymentdiv_radio').show();
			var payment_div = $('.shop-box-payment-methods'),
				payment_radios = payment_div.find(':radio'),
				payment_div_bill = payment_div.find(payment_div_bill_selector),
				payment_radio_bill = payment_div_bill.find(':radio');
			// if payment bill is selected, then set next payment method
			if (payment_radio_bill.is(':checked')) {
				payment_radios.not(payment_radio_bill).eq(0).closest('.ws_paymentdiv_main').find('.shop-paymentdiv-radio').trigger('click');
				// console.log('payment method bill changed to next payment method');
			}
			// remove payment bill
			payment_div_bill.remove(); // css('display','none');
			// console.log('payment method bill removed');
		}
	});

});
// });


// enhance/unify selects
$(document).on('ready ajaxComplete', function () {

	// $('.form-control select').selectric();
	$('.form-control select').each(function() {
		$(this).wrapAll('<span class="plain-select"></span>');
	});

});


// enhance selects place order page
$(function() {

	return;

	$('.shop-cc-input-wrapper select').prepend('<option value="empty"></option>');
	$('.shop-cc-input-wrapper select').each(function(){
		$(this)[0].selectedIndex = 0;
	});
	$('.shop-cc-input-wrapper select').trigger('change');

	// todo: werte wieder zur�ckstellen on form submit
	// Problem: WS erh�lt sinnlose Werte und f�hrt dann einen Redirect auf die Zahlungsseite aus.

});







// tooltips
$(function () { // aktiviere Bootstrap-Tooltips nur auf non-touch devices
	if(isTouchDevice()===false) {
		$(function () {
			var x = $('[data-toggle="tooltip"]').tooltip({
				// trigger: 'hover'
			});
		})
	}
});





// user-account
$(function(){

	if ($('#shop-user-account').length) { // user account page

		$('.shop-user-account-box-headline').matchHeight({
		    byRow: false,
		    property: 'height',
		    target: null,
		    remove: false
		});

		$('.shop-user-account-box-content').matchHeight({
		    byRow: false,
		    property: 'height',
		    target: null,
		    remove: false
		});


		/* // das funktioniert angeblich in modernen Browsern
		if (matchMedia) {
			const mq = window.matchMedia("(max-width: 479px)");
			mq.addListener(onMatchMediaQuery);
			onMatchMediaQuery(mq);
		}

		// media query change
		function onMatchMediaQuery(mq) {

			tt_log('media_query_match');

			// const msg = (mq.matches ? "more" : "less") + " than 500 pixels";
			// document.getElementById("current").firstChild.nodeValue = msg;
			$('.shop-user-account-box-content').matchHeight({
				remove: true
			}).css('height', 'auto');

		}
		*/

		/*  */
		function doOnBreakpoint ( breakpoint ) {
		    if ( breakpoint === 'xs' || breakpoint === 'sm' ) { // xs || sm === xxs || xs
		        $('.shop-user-account-box-content').matchHeight({
					remove: true
				}).css('height', 'auto');
		    } else {
				$('.shop-user-account-box-content').matchHeight({
				    byRow: false,
				    property: 'height',
				    target: null,
				    remove: false
				});
		    }
		};

	    window.addEventListener( 'deviceStateChanged', function( event ) {
			// console.log( 'another breakpoint was reached: ' + event.deviceState );
		    doOnBreakpoint( event.deviceState );
		}, false );
	    doOnBreakpoint(	mediaQuerySync.getDeviceState() );

	}

});



// user-account
// ???????????????????????
$(function(){

	if ($('#shop-deliv-address-manage').length) {

		$('.shop-user-account-box-headline').matchHeight({
		    byRow: false,
		    property: 'height',
		    target: null,
		    remove: false
		});

		$('.shop-user-account-box-content').matchHeight({
		    byRow: false,
		    property: 'height',
		    target: null,
		    remove: false
		});

		function doOnBreakpoint ( breakpoint ) {
		    if ( breakpoint === 'xs' || breakpoint === 'sm' ) { // xs || sm === xxs || xs
		        $('.shop-user-account-box-content').matchHeight({
					remove: true
				}).css('height', 'auto');
		    } else {
				$('.shop-user-account-box-content').matchHeight({
				    byRow: false,
				    property: 'height',
				    target: null,
				    remove: false
				});
		    }
		};

	    window.addEventListener( 'deviceStateChanged', function( event ) {
			// console.log( 'another breakpoint was reached: ' + event.deviceState );
		    doOnBreakpoint( event.deviceState );
		}, false );
	    doOnBreakpoint(	mediaQuerySync.getDeviceState() );

	}

});



// shop header useraccount button
$(function() {
	$('.shop-header-btn-account').on('click', function (e) {
		if (typeof(shop_is_logged_in)!=='undefined' && shop_is_logged_in) {
			e.preventDefault();
		}
		$('.shop-header-btn-account-menu-container .shop-header-btn-account-menu-container-slider').slideToggle();
		/*
		if ($('.shop-header-btn-account-menu-container').is(':visible')) {
		}
		if (typeof(shop_testmode)!=='undefined' && shop_testmode) {
			alert('click');
			$('.shop-header-btn-account-menu-container .shop-header-btn-account-menu-container-slider').show();
		}
		*/
	});
});





// ----- phase1 --------------------------------------------------------------------------------------------------------

$(function(){
	var $shortbasketlink = $('#marginal #marginal_shortbasket.marginal_box h3 a').eq(0),
		href = $shortbasketlink.attr('href');
	$shortbasketlink.closest('.marginal_box').on('click', function(e){
		e.preventDefault();
		document.location.href = href;
	});
});






// ---------------------------------------------------------------------------------------------------------------------
// sorry, we need them in the global scope
function getScrollbarWidth () {
	var innerWidth = window.document.documentElement['clientWidth'], // == $(window).innerWidth();
		outerWidth = window.innerWidth; // == $(window).outerWidth();
	if (outerWidth > innerWidth) {
		return outerWidth - innerWidth;
	} else {
		return 0;
	}
}

/* // old version @see basic
function bodyScrollLock () {
	var scrollY = '-' + window.scrollY + 'px',
		scrollbarWidth = getScrollbarWidth();
	document.documentElement.style.position = document.body.style.position = 'fixed'; // html / body
	document.body.style.top = scrollY;
	// compensate scrollbar width to avoid jittering content
	document.body.style.paddingRight = scrollbarWidth + 'px';
}

function bodyScrollUnlock () { // mobile menu closes
	var scrollY = document.body.style.top;
	document.documentElement.style.position = document.body.style.position = 'static'; // html / body
	window.scrollTo(0, parseInt(scrollY || '0') * -1);
	document.body.style.paddingRight = '0';
}
*/

// ---------------------------------------------------------------------------------------------------------------------

// neu-implementierung offcanvas-men�
// 2022-10 - menu via JS auf obere ebene ziehen
$(function(){

	var toggleButtons = $('.shop-offcanvas-toggle'),
		offcanvasLayer = $('#shop-nav-mobile'), // select offcanvas layer
		offcanvasLayerOverlay = $('#shop-nav-mobile-overlay'),
		showLayerClass = 'shop-nav-mobile-open',
		fadeDuration = 200;

	function _closeOffcanvasLayer () {
		offcanvasLayer.removeClass(showLayerClass);
		offcanvasLayerOverlay.fadeOut(fadeDuration);
		bodyScrollUnlock();
	}

	if (toggleButtons.length) { // offcanvas-toggle-buttons sind vorhanden

		// var offcanvasLayer = $('.shop-navbar-offcanvas').eq(0); // select offcanvas layer
		toggleButtons.on('click', function () {
			if (offcanvasLayer.hasClass(showLayerClass)) {
				bodyScrollUnlock();
			} else {
				bodyScrollLock();
				$('[id^=trustbadge-container-]').fadeOut(fadeDuration); // just fade out
			}
			offcanvasLayer.toggleClass(showLayerClass);
			offcanvasLayerOverlay.fadeToggle(fadeDuration);
		});

		$(window).on('orientationchange resize', function (e) {
			if (e.type==='resize' && typeof(SHOP_IS_TOUCH_DEVICE)!=='undefined' && SHOP_IS_TOUCH_DEVICE) {
				return;
			}
			_closeOffcanvasLayer();
		});

	}

	$('.shop-nav-mobile-button-close').on('click', _closeOffcanvasLayer);
	$('#shop-nav-mobile-overlay').on('click', _closeOffcanvasLayer);

	// menu auf oberste ebene ziehen (kopieren)
	var nav = $('#shop-nav-menu-main').clone(); // clone b/c the original is also the desktop mega menu
	$('#shop-nav-mobile').append(nav);

});



// optimize menu-link-clicks for mobile (= Link zum Kundenkonto)
$(function(){

	// verhindert, dass Klicks auf Men�punkte als Links ausgef�hrt werden, die ein Untermen� haben
	// stattdessen sollte das Touch-f�hige Betriebssystem das passende Untermen� �ffnen
	var itemWhichHasSubmenu = $('.shop-header-nav-menu-item-has-submenu');
	itemWhichHasSubmenu.children('a').on('click', function(e) {
		if (typeof(SHOP_IS_TOUCH_DEVICE)!=='undefined' && SHOP_IS_TOUCH_DEVICE) {
			// aber den Klick auf "Produkte" darf man nur verhindern, wenn es ein TOUCH DEVICE ist, aber wir noch nicht im offcanvas mode sind!
			if (!$('.shop-navbar-offcanvas').hasClass('in')) { // <- z.B. nur auf iPad, nicht auf iPhone!
				// e.preventDefault();
			}
		}
	});

	var submenuItemBlockHeadline = $('.shop-header-nav-submenu-block-headline');
	submenuItemBlockHeadline.on('click', function(){
		var block = $(this).closest('.shop-header-nav-submenu-block'),
			// blockInner = block.find('.shop-header-nav-submenu-block-inner'),
			openClass = 'shop-header-nav-submenu-block-open',
			closedClass = 'shop-header-nav-submenu-block-closed';
		if (block.hasClass(openClass)) {
			block.removeClass(openClass).addClass(closedClass);
		} else {
			block.removeClass(closedClass).addClass(openClass);
		}

	});

});





/* match heights */

$(function(){

	// startpage
	if ($('#shop-start').length) {

		// match height

		$('.shop-block-startpage-benefits-headline').matchHeight({
			byRow: true,
			property: 'height',
			target: null,
			remove: false
		});
		/*
		$('.shop-block-startpage-products-link').matchHeight({
			byRow: true,
			property: 'height',
			target: null,
			remove: false
		});
		*/



		// sup every (r)
		// enhance slider headlines
		// funktioniert nicht ...
		/*
		$('h1, h2, h3, h4, p, a').each(function(){
			var t = $(this),
				html = t.html();
			html = html.replace(/(&reg;|�)/gi, '<sup>$1</sup>');
			t.html(html);
		});
		*/


		/* ----- shop-start-carousel -------------------------------------------------------------------------------- */
		$('.carousel').bcSwipe({ threshold: 50 });

	}

	// startpage or page product overview
	if ($('#shop-start, #shop-page-product-overview').length) {

		$('.shop-block-startpage-products-item-headline').matchHeight({
			byRow: true,
			property: 'height',
			target: null,
			remove: false
		});

		$('.shop-block-startpage-products-item-scope').matchHeight({
			byRow: true,
			property: 'height',
			target: null,
			remove: false
		});

	}

});







$(function () {

	if ($('#shop-product').length) {

		// product page stepper input control
		// This button will increment the value
		$('.stepper_control_plus').on('click', function (e) {
			// Stop acting like a button
			e.preventDefault();
			// Get the field name
			var field_id = $(this).data('for');
			// Get its current value
			var currentVal = parseInt($('input[id=' + field_id + ']').val());
			// If is not undefined
			if (!isNaN(currentVal)) {
				// Increment
				$('input[id=' + field_id + ']').val(currentVal + 1);
			} else {
				// Otherwise put a 0 there
				$('input[id=' + field_id + ']').val(0);
			}
		});
		// This button will decrement the value until 0
		$('.stepper_control_minus').on('click', function (e) {
			// Stop acting like a button
			e.preventDefault();
			// Get the field name
			var field_id = $(this).data('for');
			// Get its current value
			var currentVal = parseInt($('input[id=' + field_id + ']').val());
			// If it isn't undefined or its greater than 0
			if (!isNaN(currentVal) && currentVal > 0) {
				// Decrement one
				$('input[id=' + field_id + ']').val(currentVal - 1);
			} else {
				// Otherwise put a 0 there
				$('input[id=' + field_id + ']').val(0);
			}
		});


		// shop-pr-price-table-row-link-4 - hover
		$('.shop-pr-price-table-row-link-4').on('mouseenter', function(){
			var self = $(this),
				input = self.find('.shop-pr-price-table-button').eq(0),
				srcOrg = input.attr('src'),
				srcHvr = '../euramin-2018/images/icons/global/v2-basket-light.svg';
			input.data('src-org', srcOrg).attr('src', srcHvr);
		}).on('mouseleave', function(){
			var self = $(this),
				input = self.find('.shop-pr-price-table-button').eq(0),
				srcOrg = input.data('src-org');
			input.attr('src', srcOrg);
		});



		// ----- mobile fixed button-pr-to-basket on product pages -----------------------------------------------------

		var shop_btn_pr_to_basket_wrapper_fixed_class = 'shop-btn-pr-to-basket-wrapper-fixed',
			shop_product_buybox_main_class = 'shop-product-order-box',
			shop_btn_pr_to_basket_class = 'shop-btn-pr-to-basket';

		$('.' + shop_btn_pr_to_basket_wrapper_fixed_class + ' .' + shop_btn_pr_to_basket_class).on('click', function () {
			$('.' + shop_product_buybox_main_class + ' .' + shop_btn_pr_to_basket_class).trigger('click');
		});

		$(window).on('scroll', function () {
			var button = $('.' + shop_product_buybox_main_class + ' input.' + shop_btn_pr_to_basket_class),
				offset_below_button = button.offset().top + button.height() - $('.eu-header-sticky').height();
			if ($(window).outerWidth()<768 && $(this).scrollTop()>offset_below_button) {
				$('.' + shop_btn_pr_to_basket_wrapper_fixed_class).fadeIn(0);
			} else {
				$('.' + shop_btn_pr_to_basket_wrapper_fixed_class).fadeOut(0);
			}
		}).on('resize', function() {
			var button = $('.' + shop_product_buybox_main_class + ' input.' + shop_btn_pr_to_basket_class),
				offset_below_button = button.offset().top + button.height() - $('.eu-header-sticky').height();
			if ($(window).outerWidth()<768 && $(this).scrollTop()>offset_below_button) {
				$('.' + shop_btn_pr_to_basket_wrapper_fixed_class).fadeIn(0);
			} else {
				$('.' + shop_btn_pr_to_basket_wrapper_fixed_class).fadeOut(0);
			}
		});

	}

});









// subshop-specific scripts

$(function() {

	if (typeof(shop_subshop_id!=='undefined')) {

		function getCookie(c_name) {
			var i, x, y, ARRcookies = document.cookie.split(";");
			for (i = 0; i < ARRcookies.length; i++) {
				x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
				y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
				x = x.replace(/^\s+|\s+$/g, "");
				if (x == c_name) {
					return unescape(y);
				}
			}
		};

		function setCookie(c_name, value, exdays) {
			var exdate = new Date();
			exdate.setDate(exdate.getDate() + exdays);
			var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString() + "; path=/");
			document.cookie = c_name + "=" + c_value;
		};

		/* brexit notice modal layer */
		if (shop_subshop_id==='07-aa') { // == UK

			// if ($('html.shop-testmode').length) {

				var brexitCookieName = 'custom_brexit_notice';
				var brexitCookieChk = getCookie(brexitCookieName);

				if (typeof(brexitCookieChk)==='undefined') {

					// no cookie exists, so show notice
					$.colorbox({
						html:
							"<h1 style='text-align:center;'>Important information</h1>" +
							"<p style='text-align:center;'><b>No deliveries to UK for the near future</b></p>" +
							"<p style='text-align:center;'>Dear Customer,</p>" +
							"<p style='text-align:center;'>please note, that we won't fulfil deliveries to the United Kingdom for the near future. " +
							"We are currently working to meet the Brexit-Regularities to be able to fulfil deliveries to UK.</p>" +
							"<p style='text-align:center;'>Thank you for your patience.</p>" +
							"<p style='text-align:center;'>Your euramin-Team</p>",
						close: 'close',
						initialWidth: '320px',
						initialHeight: '220px',
						width: '640px',
						height: '440px',
						maxWidth: '90%',
						maxHeight: '90%',
						opacity: 0.65
					});

				}

				console.log('set cookie');
				setCookie(brexitCookieName, null, null); // set session cookie

			// }

		}

	}

});






// etracker opt out
$(function(){

	if ($('#shop-page-privacy-policy').length || $('#shop-confirm').length) {

		function waitForEtracker(callback, timeout, interval) {
			timeout = timeout || 5000;  // Maximum waiting time in ms
			interval = interval || 100; // Polling interval in ms

			var startTime = Date.now();

			(function poll() {
				// Check if _etracker is defined
				if (window._etracker !== undefined) {
					callback();
				} else if (Date.now() - startTime < timeout) {
					// If not defined, wait and try again
					setTimeout(poll, interval);
				} else {
					console.error('Timed out waiting for _etracker');
				}
			})();
		}

		waitForEtracker(function () {
			// Now you can safely access the _etracker object
			// console.log(_etracker);

			// console.log('page privacy policy');

			var btn = '#shop-et-opt-out',
				$btn = $(btn);

			// console.log(shop_domain);

			if (_etracker.isTrackingEnabled()) {

				$btn.html(shop_et_opt_out_btn_et_enabled);

			} else {

				$btn.html(shop_et_opt_out_btn_et_disabled);

			}

			$btn.on('click', function(e){

				var self = $(this);
				e.preventDefault();

				if (_etracker.isTrackingEnabled()) {

					_etracker.disableTracking(shop_domain);
					self.html(shop_et_opt_out_btn_et_disabled);

				} else {

					_etracker.enableTracking(shop_domain);
					self.html(shop_et_opt_out_btn_et_enabled);

				}

				// window.location.reload();

			});

		});

	}

});









// websale bootstrap enhancements

$(document).on('click', '.openmodal', function(event) {
	// "use strict";
	event.preventDefault();
	$($(this).attr('data-modal-target-body')).load($(this).attr('href') + ' .ajaxcontent');                             // l�dt von der Zielseite nur das Fragment ".ajaxcontent", see: http://api.jquery.com/load/#loading-page-fragments
	$($(this).attr('data-modal-target')).modal('show');
});





/*
$(function(){

	// bse implements toggling button when clicking parent or other element
	// Achtung: es funktioniert derzeit nur mit <a>-Tags als Buttons ...
	// Todo: noch Unterst�tzung f�r <button> implementieren (closest form suchen und action auslesen usw...)


	$('*[data-bse-toggle]').each(function(){
		var self = $(this),
			mode = self.data('bse-toggle'),
			target = $(self.data('bse-target'));
		switch (mode) {
			case 'button':
				target.on('click', function(e){
					e.stopPropagation();
				});
				self
					.css('cursor','pointer')
					.on('click', function(e){
						document.location.href = target.attr('href');
					})
				;

			default:
				return;
		}
	});

});
*/










$(function(){

	// bse implements toggling button when clicking parent or other element
	// der Button muss innerhalb des Containers liegen
	// Todo: noch Unterst�tzung f�r <button> implementieren (closest form suchen und action auslesen usw...)
	// USAGE EXAMPLE:
	// <div class="container" data-bse-toggle="button" data-bse-target="#shop-block-with-button-somewhere-inside"> ...
	// Parameter:
	// bse-toggle = button
	// ...

	$('*[data-bse-toggle]').each(function(){
		var self = $(this),
			mode = self.data('bse-toggle'),
			target = $(self.data('bse-target'));
		switch (mode) {
			case 'button':
				target.on('click', function(e){
					e.stopPropagation();
				});
				self
					.css('cursor','pointer')
					.on('click', function(e){
						document.location.href = target.attr('href');
					})
				;
				break;

			case 'layer':
				self.on('click', function(e){
					e.preventDefault();
					e.stopPropagation();
					target.layerToggle();
				});
				break;

			case 'enter2click':
				self.on('keypress', function(e) {
					// get key pressed (charCode from Mozilla/Firefox and Opera / keyCode in IE)
					var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0;
					// suppress enter/return key
					if (key == 13) {
						e.preventDefault();
						e.stopPropagation();
						target.click();
						// return false;
					}
				});
				break;

			case 'enter2change':

				function doOnKeypress (e) {
					// if ($(e.target).is(self)) {
						// get key pressed (charCode from Mozilla/Firefox and Opera / keyCode in IE)
						var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0;
						// suppress enter/return key
						if (key == 13) {
							e.preventDefault();
							e.stopPropagation();
							// console.log($(e.target));
							$(e.target).trigger('change');
						}
					// }
				}
				$(document).on('keypress', self, doOnKeypress);
				break;

			default:
				return;
		}
	});


});










// ----- paginierung prodrating ----------------------------------------------------------------------------------------

$(function(){

	// if ($('html.shop-testmode').length) {

		$(document).on('ajaxComplete', function () {

			var activeButtonClass = 'active',
				pageClass = 'shop-prodrating-list-block',
				activePageClass = 'shop-prodrating-list-block-active',
				pageButtonClass = 'shop-prodrating-list-pagination-btn',
				counterCurrent = $('.shop-prodrating-list-pagination-counter-current'),
				pageButtonStart = $('.shop-prodrating-list-pagination-btn-start'),
				pageButtonEnd = $('.shop-prodrating-list-pagination-btn-end'),
				pageButtonNext = $('.shop-prodrating-list-pagination-btn-next'),
				pageButtonPrev = $('.shop-prodrating-list-pagination-btn-prev');

			$('.' + pageClass).hide();
			$('.' + activePageClass).show();
			// $('.' + pageButtonClass).eq(0).addClass(activeButtonClass);

			$('.' + pageButtonClass).on('click', function(e) {

				e.preventDefault();

				var target = $(this).data('page'),
					activePage = $('.' + pageClass + '.' + activePageClass).eq(0).index() + 1,
					pageCount = $('.' + pageClass).length,
					pageButtonCount = $('.' + pageButtonClass).length - 1;

				// update active page
				$('.' + pageClass).hide().removeClass(activePageClass);

				if (target === '+1') {

					target = activePage + 1;

					if (target > pageCount) {
						target = pageCount;
					}

				} else if (target == '-1') {

					target = activePage - 1;

					if (target <= 0) {
						target = 1;
					}

				}

				$('.' + pageClass + '[data-page="' + target + '"]').show().addClass(activePageClass);

				// update button styles
				$('.' + pageButtonClass).addClass(activeButtonClass);
				if (target == 1) {
					pageButtonStart.removeClass(activeButtonClass);
					pageButtonPrev.removeClass(activeButtonClass);
				} else if (target == pageCount) {
					pageButtonEnd.removeClass(activeButtonClass);
					pageButtonNext.removeClass(activeButtonClass);
				}

				// update page counter
				counterCurrent.text(target);

				// scroll up into view
				$.scrollTo($('#ws_prodrating_content').eq(0), {
					axis: 'y',
					offset: -5,
					duration: 600
				});

			});

		});

	// }

});














